/**
 * Canonical public URL helper.
 *
 * Returns the user-facing URL of this app — used to build shareable links
 * (OBS overlay URL, copy-link buttons, deep links to tournaments, etc.).
 *
 * Resolution order:
 *   1. `REACT_APP_PUBLIC_URL` env var if set (e.g. https://annadilburhanidar.bluedigital.co.tz)
 *      — set this in /app/frontend/.env so every share link uses your custom
 *      domain regardless of which environment the admin is browsing.
 *   2. `window.location.origin` — the current host. Works fine once the user
 *      is actually visiting the production custom domain.
 *
 * Always returns the origin (no trailing slash).
 */
export function publicOrigin() {
  const fromEnv = (process.env.REACT_APP_PUBLIC_URL || "").trim().replace(/\/+$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, "");
  }
  return "";
}

/**
 * Build a public, shareable URL for a route within the app.
 * Pass the path WITHOUT the leading slash (or with it; both work).
 *   shareLink("tournaments/k-cup-2026/bracket")
 *   → "https://annadilburhanidar.bluedigital.co.tz/tournaments/k-cup-2026/bracket"
 */
export function shareLink(path = "") {
  const origin = publicOrigin();
  const clean = String(path).replace(/^\/+/, "");
  return clean ? `${origin}/${clean}` : origin;
}
